<template lang="pug">
	.about
		.poster
			.wrapper.wrapper_full
				.poster__swiper
					.poster__bg(data-aos="fade" :style="{backgroundImage: 'url(\"'+ settings.about_first_image +'\")'}")
					.poster__outer
						.poster__inner
							.wrapper
								.poster__content(data-aos="fade-up" data-aos-delay="200")
									.poster__container
										.poster__title(v-text="settings.about_main_title")
										.poster__subtitle(v-text="settings.about_main_subtitle")

		.content(data-aos="fade-up")
			p Нові сільськогосподарські рішення FMC тепер мають більш широкий портфель провідних брендів, більш глибокий конвеєр нових технологій, більший глобальний масштаб, а також науково-дослідні розробки світового рівня, які задовольнять потреби клієнтів краще, ніж будь-коли.
		.item
			.wrapper
				.item__image.item__image_mobile(data-aos="fade" :style="{backgroundImage: 'url(\"'+ settings.about_second_image +'\")'}")
				.item__content(data-aos="fade-up" data-aos-delay="200")
					.item__inner
						.item__title(v-text="settings.about_second_title")
						.item__subtitle(v-text="settings.about_second_subtitle")
				.item__image(data-aos="fade" :style="{backgroundImage: 'url(\"'+ settings.about_second_image +'\")'}")
		.content(v-html="settings.about_second_content" data-aos="fade-up")
		.about__bottom(data-aos="fade-up")
			router-link.about__more(to='/products/') Каталог продуктів
				span
</template>

<script>

	import BlockHeader from '@/blocks/includes/header.vue';
	import BlockFooter from '@/blocks/includes/footer.vue';
  import appBanner from '@/components/appBanner.vue';

	import AOS from 'aos';

	import {mapState} from 'vuex';

	export default {
		name: 'About',
		metaInfo: function() {

			return {
				title: 'Про компанію',
			}
		},
		computed: {
			...mapState([
				'settings',
        'withBanner',
        'desk'
			])
		},
		mounted() {
			this.$nextTick(() => {
				AOS.init({
					once: true,
					disabled: 'mobile',
					duration: 1000
				});
			})
		},
		components: {
			'block-header': BlockHeader,
			'block-footer': BlockFooter,
      appBanner,
		}
	}

</script>

<style lang="scss" scoped>

	@import '@/helpers/sass/kit.scss';

	.poster {
		height: 518px;
		position: relative;

		.wrapper {
			height: 100%;
		}

		&__swiper {
			height: 100%;
		}

		&__bg {
			position: absolute;
			height: 100%;
			width: calc(100% - 325px - 80px);
			left: 0;
			top: 0;
			background-size: cover;
			background-position: center;
		}

		&__outer {
			position: absolute;
			width: 100%;
			height: 100%;
			top: 0;
			left: 0;
			font-size: 0;
			text-align: right;

			&:before {
				content: "";
				display: inline-block;
				vertical-align: middle;
				height: 100%;
			}
		}

		&__content {
			background-color: #fff;
			width: 630px;
			height: 368px;
			display: inline-block;
			position: relative;
			padding: 28px 70px 0 131px;
			text-align: left;
			box-shadow: 0px 12px 20px rgba(51, 51, 51, 0.05);
			font-size: 0;

			&:before {
				content: "";
				display: inline-block;
				vertical-align: middle;
				height: 100%;
			}
		}

		&__inner {
			display: inline-block;
			vertical-align: middle;
			width: 100%;
			margin-top: -50px;
		}

		&__subtitle {
			@include kit('featureSubtitle');
			margin-top: 14px;
			letter-spacing: 1.3px;
		}

		&__title {
			@include kit('featureTitle');
			margin-top: 0;
			text-transform: uppercase;
		}

		&__text {
			@include kit('featureText');
		}

		&__container {
			display: inline-block;
			vertical-align: middle;
		}
	}

	.numbers {
		margin: 50px 0 100px;

		&__title {
			@include kit('sectionTitle');
			margin-left: 0;
		}

		&__list {
			font-size: 0;
			margin-top: 80px;
		}

		.card {
			display: inline-block;
			vertical-align: top;
			width: 20%;
			text-align: center;

			&__icon {
				height: 92px;
				display: inline-block;
				vertical-align: top;
			}

			&__number {
				margin-top: 20px;
				font: 700 28px/33px 'Helvetica', Arial, sans-serif;
				letter-spacing: 1px;
				height: 50px;
			}

			&__title {
				font: 21px/25px 'Helvetica', Arial, sans-serif;
			}
		}
	}

	.about {
		margin-bottom: 100px;

		&__bottom {
			height: 50px;
			width: 328px;
			max-width: calc(100% - 40px);
			border: 1px solid #EF3E33;
			display: inline-block;
			vertical-align: top;
			text-transform: uppercase;
			margin-top: -6px;
			padding-right: 50px;
			text-align: center;
			color: #EF3E33;
			font: 500 19px/52px 'Helvetica', Arial, sans-serif;
			letter-spacing: 2px;
			position: relative;
			left: 50%;
			transform: translateX(-50%) !important;
			top: 10px;

			@media screen and (max-width: 1200px) {
				font-size: 17px;
			}

			span {
				display: block;
				position: absolute;
				top: 0;
				right: 0;
				width: 50px;
				height: 100%;
				background: url('../assets/img/arr_3.svg') no-repeat center center;
				border-left: 1px solid #EF3E33;
			}
		}
	}

	.content {
		font: 300 14px/18px 'Helvetica', Arial, sans-serif;
		max-width: 630px;
		margin: 50px auto 44px;
		letter-spacing: .7px;

    >>> p {
			margin: 10px 0;
			line-height: inherit;
		}

    >>> h4 {
			font: 700 21px/21px 'Helvetica', Arial, sans-serif;
		}

    >>> strong {
			font-weight: 700;
		}

    >>> img {
			width: calc(100% + 216px);
			margin: 44px 0 48px -108px;
			display: block;
			height: auto;
		}
	}

	.item {
		font-size: 0;

		&__title {
			@include kit('sectionTitle');
			color: #EF3E33;
			text-transform: uppercase;
		}

		&__subtitle {
			margin-top: 12px;
			font-size: 18px;
			line-height: 23px;
			letter-spacing: .8px;
		}

		&__content {
			display: inline-block;
			vertical-align: top;
			width: 630px;
			height: 368px;
			background-color: #fff;
			margin-top: 50px;
			box-shadow: 0px 12px 20px rgba(51, 51, 51, 0.05);

			&:before {
				content: "";
				display: inline-block;
				vertical-align: middle;
				height: 100%;
			}
		}

		&__inner {
			display: inline-block;
			vertical-align: middle;
			width: 100%;
			padding: 10px 55px 0 109px;
		}

		&__image {
			display: inline-block;
			vertical-align: top;
			width: calc(100% - 630px);
			height: 468px;
			background-size: cover;
			background-position: center;

			&_mobile {
				display: none;
			}
		}
	}

	@media screen and (max-width: 1200px) {
		.poster {
			height: 450px;
			margin-bottom: 80px;

			&__title {
				@include kit('featureTitle');
			}

			&__bg {
				width: 100%;
				height: 370px;
			}

			&__content {
				width: 100%;
				padding: 20px;
				height: auto;
			}

			&__outer {
				&:before {
					display: none;
				}
			}

			&__inner {
				margin-top: 0;
				display: block;
				position: absolute;
				top: 300px;
				left: 0;
			}
		}

		.content {
			padding: 0 20px;
		}

		.item {
			&__image {
				display: none;

				&_mobile {
					display: block;
					width: 100%;
					height: 335px;
					position: relative;
					z-index: 1;
				}
			}

			&__content {
				margin-top: -50px;
				width: calc(100% + 40px);
				margin-left: -20px;
				height: auto;
				padding-top: 76px;
			}

			&__inner {
				padding: 20px 20px 24px 20px;
			}

			&__title {
				text-transform: none;
			}

			&__subtitle {
				margin-top: 18px;
				line-height: 1;
			}
		}

		.numbers {

			.card {
				width: 100%;
				display: block;
				margin-bottom: 50px;
			}
		}
	}

</style>
